import React, { useEffect, useState } from 'react'
import { 
  LightModeOutlined,
  DarkModeOutlined,
  Menu as MenuIcon,
  Search,
  SettingsOutlined,
  ArrowDropDownOutlined
  } from '@mui/icons-material';
import FlexBetween from './FlexBetween';
import { connect, useDispatch, useSelector } from 'react-redux';
//import { setMode } from 'state';
import profileImage from "../assets/profile.png";
import { AppBar,Box,Button,IconButton,InputBase,Menu,MenuItem,Toolbar,Typography,useTheme } from '@mui/material';
import { themeSettings } from "../theme/theme";
import { useNavigate } from 'react-router-dom';
import { signOut } from '../redux/actions/signIn';

const Navbar = ({props,user,signout,isSidebarOpen, setIsSidebarOpen}) => {
  const mode = useSelector((state) => state.global.mode);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [anchorEl,setAnchorEl] = useState(null);
  const isOpen = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  const handleSignout = (event) => {
    event.stopPropagation();
    setAnchorEl(null);
    signout();
  }

  return (
    <AppBar
    elevation={1}
    position='fixed'
    sx={{
      width: isSidebarOpen ? "calc(100% - 250px)" : "100%", 
      ml: isSidebarOpen ? "250px" : "0",
      transition: "all 0.3s ease",
      //position:"static",
      background: themeSettings(mode).palette.background.alt,
      color: themeSettings(mode).palette.secondary[200],
      boxShadow:"none",
    }}>
      <Toolbar sx={{
        justifyContent:"space-between",
      }}>
        {/* LEFT SIDE */}
        <FlexBetween>

          {/* <IconButton onClick={()=>{setIsSidebarOpen(!isSidebarOpen)}}>
            <MenuIcon/>
          </IconButton> */}
          
          {/* <FlexBetween
          backgroundColor={themeSettings(mode).palette.background.alt}
          borderRadius={"9px"}
          gap={"3rem"}
          p="0.1rem 1.5rem"
          >
            <InputBase
            placeholder='Search...'
            />
            <IconButton>
              <Search />
            </IconButton>
          </FlexBetween> */}
        </FlexBetween>

        {/* RIGHT SIDE */}
        <FlexBetween gap={"1.5rem"}>
          {/* <IconButton onClick={()=>{//dispatch(setMode())
          }}>
            {
              themeSettings(mode).palette.mode === "dark" ?
              (
                <DarkModeOutlined sx={{fontSize:"25px"}}/>
              ):(
                <DarkModeOutlined sx={{fontSize:"25px"}}/>
              )
            }
          </IconButton> */}
          {/* <IconButton>
            <SettingsOutlined sx={{fontSize:"25px"}}/>
          </IconButton> */}
        
            <Button onClick={handleClick} sx={{display:"flex",justifyContent:"space-between",alignItems:"center",textTransform:"none",gap:"0.5rem",}}>
            <Box
              component={"img"}
              alt="profile"
              src={profileImage}
              height={"32px"}
              width={"32px"}
              borderRadius={"50%"}
              sx={{objectFit:"cover"}}
              />

                <Box textAlign={"left"}>
                  <Typography 
                  fontWeight={"bold"} 
                  fontSize={"0.85rem"}
                  sx={{color:themeSettings(mode).palette.secondary[100]}}
                  >
                    {user?.email}
                  </Typography>
                  {/* <Typography 
                  fontSize={"0.75rem"}
                  sx={{color:themeSettings(mode).palette.secondary[200]}}
                  >
                    {user.occupation}
                  </Typography> */}
                  </Box>
                  <ArrowDropDownOutlined sx={{color:themeSettings(mode).palette.secondary[300],fontSize:"25px"}}/>
            </Button>
            <Menu anchorEl={anchorEl} open={isOpen} 
             onClose={handleClose} 
            anchorOrigin={{vertical:"bottom",horizontal:"center"}}>
              <MenuItem onClick={
                handleSignout
                }>Log Out</MenuItem>
            </Menu>
        </FlexBetween>
      </Toolbar>
    </AppBar>
  )
}

// mapStateToProps (to access Redux state)
const mapStateToProps = (state) => {
  return {
    
  }
 };

// mapDispatchToProps (to dispatch Redux actions)
const mapDispatchToProps = (dispatch) => ({});

// connect to Redux
export default connect(mapStateToProps, mapDispatchToProps)(Navbar);

//export default Navbar